import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskCmdbAssetsReportsRoute: InvariantJiraRoute = {
	name: 'servicedesk-cmdb-assets-reports-default-redirect',
	path: '/jira/servicedesk/assets/reports',
	exact: true,
};
